import { useAuth } from '../AuthContext/AuthContext'
import { Navigate } from 'react-router-dom'

export default function AdminRoute({ children }) {
  const { user, isAdmin, loading } = useAuth()

  if (loading) return <p>Загрузка...</p>

  if (!user) return <Navigate to="/auth" replace />

  if (!isAdmin) return <Navigate to="/" replace />

  return children
}
